import { useTranslation } from "react-i18next";
import { FolderOpen, Inbox } from "lucide-react";
import type { PaneEmptyStateProps } from "./types";

export const PaneEmptyState = ({ isUnsorted }: PaneEmptyStateProps) => {
  const { t } = useTranslation();

  const Icon = isUnsorted ? Inbox : FolderOpen;

  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-2 px-6 text-center text-sm text-gray-500">
      <Icon className="h-8 w-8 text-gray-400" strokeWidth={1.5} />
      <span className="font-medium text-gray-700">
        {t(
          isUnsorted
            ? "smartSurveyor.folders.suggestion.emptyUnsorted"
            : "smartSurveyor.folders.suggestion.emptyFolder",
        )}
      </span>
      {!isUnsorted && t("smartSurveyor.folders.suggestion.emptyFolderHint")}
    </div>
  );
};
